
 export function throwReportDownloadError(id: number) {
  throw new Error('ERROR downloading file with ID: ' + id);
}
